import { useState } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import Login from "../Pages/Login/login";

import ModuloADS from "../Pages/ModuloAds";
import NotFound from "../Pages/Errors/NotFound";

import "../Assets/plugins/global/plugins.bundle.css";
import "../Assets/plugins/custom/prismjs/prismjs.bundle.css";
import "../Assets/css/style.bundle.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

import PrivatedRoute from "./PrivatedRoute";

//Context
import { AtendimentoProvider, useAtedimento } from "../Context/Atendimento";
import { NotificacaoAlertaProvider } from "../Context/NotificacaoAlerta";

import { OverlayTrigger, Tooltip } from "react-bootstrap";

import "./styles.css";

import { ACESSOS } from "./Acessos";
import { useStorage } from "../hooks/useStorage";
import { ModuloInfoProvider } from "../Context/ModuloInfo";

//Rotas
import RotasGeral from "./Rotas/RotasGeral";
import RotasCobranca from "./Rotas/RotasCobranca";
import RotasAtendimento from "./Rotas/RotasAtendimento";
import RotasAssistencia from "./Rotas/RotasAssistencia";
import RotasVendas from "./Rotas/RotasVendas";
import RotasRepasse from "./Rotas/RotasRepasse";
import RotasHelpDesk from "./Rotas/RotasHelpDesk";
import Footer from "./Footer";
import Header from "./Header/Header";
import RotasGlobais, { pathRotasGlobais } from "./Rotas/RotasGlobais";
import AgendaAssistenciaTecnica from "../Pages/AssistenciaTecnica/AgendaAssistenciaTecnica";
import RotasEntregaDeChaves from "./Rotas/RotasEntregaChaves";
import ResponderFormularioLink from "../Pages/Geral/Formularios/ResponderFormularioLink";
import ResponderPesquisaSatisfacao from "../Pages/Geral/Formularios/ResponderPesquisaSatisfacao";
import RotasAutomacao from "./Rotas/RotasAutomacao";
import AgendamentoPeloClienteVistoria from "../Pages/Geral/AgendamentoPeloClienteVistoria";

function Router() {
    return (
        <BrowserRouter>
            <ModuloInfoProvider>
                <NotificacaoAlertaProvider>
                    <AtendimentoProvider>
                        <Routes />
                    </AtendimentoProvider>
                </NotificacaoAlertaProvider>
            </ModuloInfoProvider>
        </BrowserRouter>
    );
}

function Routes() {
    const [ProfileMobile, setProfileMobile] = useState("");
    const { modoAtendimento, fila } = useAtedimento();

    const loginRoute = useStorage<boolean>("DEFAULT_LOGIN_ONLY_SSO")[0]
        ? "/sso"
        : "/login";

    return (
        <>
            <Switch>
                <Route path="/" exact>
                    <Redirect to={loginRoute} />
                </Route>
                <PrivatedRoute
                    path={["/login", "/recuperarSenha/:token", "/sso"]}
                    component={Login}
                    exact
                />
                <Route
                    path={"/ResponderPesquisaSatisfacao/:Token"}
                    component={ResponderPesquisaSatisfacao}
                />
                <Route
                    path={"/FazerAgendamentoVistoria/:Token"}
                    component={AgendamentoPeloClienteVistoria}
                />
                <Route
                    path={"/ResponderFormulario/:formulario/:idOrg/:guid"}
                    component={ResponderFormularioLink}
                    exact
                />
                <PrivatedRoute
                    path={ACESSOS.OUTROS.TELAS.AGENDA.DS_PATH}
                    idTela={ACESSOS.OUTROS.TELAS.AGENDA.ID_TELA}
                    component={AgendaAssistenciaTecnica}
                    isPrivate
                />
                <Route
                    path={[
                        ACESSOS.GERAL.DS_BASE_URL,
                        ACESSOS.ATENDIMENTO.DS_BASE_URL,
                        ACESSOS.COBRANCA.DS_BASE_URL,
                        ACESSOS.ASSISTENCIA.DS_BASE_URL,
                        ACESSOS.VENDAS.DS_BASE_URL,
                        ACESSOS.REPASSE.DS_BASE_URL,
                        ACESSOS.ENTREGA_DE_CHAVES.DS_BASE_URL,
                        // '/PortalAdmin',
                        ACESSOS.HELPDESK.DS_BASE_URL,
                        ACESSOS.AUTOMACAO.DS_BASE_URL,
                        "/Errors401",
                    ]}
                >
                    <div
                        id="BodyTempalte"
                        className={`header-fixed header-mobile-fixed header-bottom-enabled subheader-enabled ${ProfileMobile}`}
                    >
                        <div className="d-flex flex-column flex-root">
                            <div className="d-flex flex-row flex-column-fluid page container-capys">
                                <div
                                    id="kt_wrapper"
                                    className="d-flex flex-column flex-row-fluid wrapper container-capys"
                                >
                                    <Header
                                        setProfileMobile={setProfileMobile}
                                    />

                                    <div
                                        id="kt_content"
                                        className="content d-flex flex-column flex-column-fluid"
                                    >
                                        {modoAtendimento && fila && (
                                            <div className="w-100 d-flex flex-column align-items-center justify-content-center d-lg-none bg-white py-5">
                                                <h5 className="m-0">
                                                    Modo Atendimento ativado
                                                    <OverlayTrigger
                                                        overlay={
                                                            <Tooltip id="tooltip-disabled">
                                                                Com o modo
                                                                atendimento
                                                                ativado, você só
                                                                pode acessar a
                                                                página de
                                                                atendimento de
                                                                cobrança. Assim
                                                                que você acabar
                                                                um atendimento,
                                                                você será
                                                                automaticamente
                                                                direcionado para
                                                                o próximo.
                                                            </Tooltip>
                                                        }
                                                        placement="bottom"
                                                    >
                                                        <FontAwesomeIcon
                                                            className="ml-3"
                                                            icon={faInfoCircle}
                                                        />
                                                    </OverlayTrigger>
                                                </h5>
                                                <span>
                                                    Fila: {fila.DS_GRUPO}
                                                </span>
                                            </div>
                                        )}
                                        <div className="d-flex flex-column-fluid">
                                            <div className="container-fluid">
                                                <hr />

                                                <Switch>
                                                    <Route
                                                        path={pathRotasGlobais}
                                                    >
                                                        <RotasGlobais />
                                                    </Route>

                                                    <Route
                                                        path={
                                                            ACESSOS.GERAL
                                                                .DS_BASE_URL
                                                        }
                                                    >
                                                        <RotasGeral />
                                                    </Route>

                                                    <Route
                                                        path={
                                                            ACESSOS.COBRANCA
                                                                .DS_BASE_URL
                                                        }
                                                    >
                                                        <RotasCobranca />
                                                    </Route>

                                                    <Route
                                                        path={
                                                            ACESSOS.ATENDIMENTO
                                                                .DS_BASE_URL
                                                        }
                                                    >
                                                        <RotasAtendimento />
                                                    </Route>

                                                    <Route
                                                        path={
                                                            ACESSOS.ASSISTENCIA
                                                                .DS_BASE_URL
                                                        }
                                                    >
                                                        <RotasAssistencia />
                                                    </Route>

                                                    <Route
                                                        path={
                                                            ACESSOS.VENDAS
                                                                .DS_BASE_URL
                                                        }
                                                    >
                                                        <RotasVendas />
                                                    </Route>

                                                    <Route
                                                        path={
                                                            ACESSOS.REPASSE
                                                                .DS_BASE_URL
                                                        }
                                                    >
                                                        <RotasRepasse />
                                                    </Route>

                                                    <Route
                                                        path={
                                                            ACESSOS
                                                                .ENTREGA_DE_CHAVES
                                                                .DS_BASE_URL
                                                        }
                                                    >
                                                        <RotasEntregaDeChaves />
                                                    </Route>

                                                    <Route path="/PortalAdmin">
                                                        <Route
                                                            path="/PortalAdmin/:idModulo/"
                                                            exact
                                                            component={
                                                                ModuloADS
                                                            }
                                                        />
                                                    </Route>

                                                    <Route
                                                        path={
                                                            ACESSOS.HELPDESK
                                                                .DS_BASE_URL
                                                        }
                                                    >
                                                        <RotasHelpDesk />
                                                    </Route>
                                                    <Route
                                                        path={
                                                            ACESSOS.AUTOMACAO
                                                                .DS_BASE_URL
                                                        }
                                                    >
                                                        <RotasAutomacao />
                                                    </Route>
                                                </Switch>
                                            </div>
                                        </div>
                                    </div>

                                    <Footer />
                                </div>
                            </div>
                        </div>
                    </div>
                </Route>
                <Route component={NotFound} />
            </Switch>
        </>
    );
}

export default Router;
